import axios from "axios";

import {
  getRequestCancellationToken,
  getRequestConfig,
  generateCancellationTokenSource,
  throwCatchedError,
} from "../utils";

import { TTP_API_URL, ARTICLE_LIMIT } from "../config";

let getArticlesCTS;

export const getArticles = (
  token,
  filters,
  scope = "PUBLIC,COLLABORATOR",
  options,
  cancellationTokenSource = null
) => {
  let requestCancellationToken = getRequestCancellationToken(
    getArticlesCTS,
    cancellationTokenSource
  );

  options = options || {};
  filters = filters || {};

  const limit = options.limit || ARTICLE_LIMIT;
  const page = options.page || 1;

  const fields = [
    "*",
    "url",
    "introduction",
    "author",
    "main_media",
    "category",
    "tags",
    "image_reduced",
    "organization",
    "avatars",
    "pages",
    "theme",
    "type",
    "social",
  ];
  const requestUrl = `${TTP_API_URL}/blog/article`;

  const filterData = [
    {
      property: "isExternal",
      value: 0,
      operator: "eq",
    },
    {
      property: "status",
      value: "PUBLISHED",
      operator: "eq",
    },
    {
      property: "csScope",
      value: scope,
      operator: "in",
    },
    {
      property: "organization.id",
      value: "9",
      operator: "eq",
    },
  ];

  if (filters.search) {
    filterData.push({
      property: "word",
      value: encodeURI(filters.search),
      operator: "like",
    });
  }

  if (filters.languages) {
    filterData.push({
      property: "language",
      value: filters.languages,
      operator: "in",
    });
  } else {
    filterData.push({
      property: "language",
      value: "fr",
      operator: "in",
    });
  }

  if (filters.categories) {
    filterData.push({
      property: "category.id",
      value: filters.categories,
      operator: "in",
    });
  }

  const sort = [
    {
      property: "publishedAt",
      dir: "desc",
    },
  ];

  let params = {
    access_token: token,
    filter: JSON.stringify(filterData),
    sort: JSON.stringify(sort),
    fields: fields.join(","),
    limit: limit,
    start: options.start ? options.start : (page - 1) * limit,
  };

  let requestConfig = getRequestConfig(params, requestCancellationToken);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const getCategories = ({
  token,
  language = "fr",
  customFilter = null,
}) => {
  const requestUrl = `${TTP_API_URL}/blog/category`;

  let filter = [];

  filter.push({
    property: "language",
    value: language,
    operator: Array.isArray(language) ? "in" : "like",
  });

  if (customFilter !== null) {
    if (Array.isArray(customFilter)) {
      filter.push(...customFilter);
    } else {
      filter.push(customFilter);
    }
  }

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      nolimit: 1,
    },
  });
};

export const getChains = ({ token, language = "fr" }) => {
  const requestUrl = `${TTP_API_URL}/blog/avatar`;
  const fields = ["*", "mediaChain"];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      fields: fields.join(","),
    },
  });
};

export const getTops = ({ token, language = "fr" }) => {
  const requestUrl = `${TTP_API_URL}/blog/article/organization/fff/top`;
  const filters = [
    {
      property: "language",
      value: language,
      operator: "eq",
    },
  ];
  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filters),
    },
  });
};
